import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { PageHead } from "./Shop";
import { processSteps } from "../mock/mock";
import useSeo from "../hooks/useSeo";

const Process = () => {
  const { tr, ui } = useLang();
  useSeo({
    title: ui.howWeDo,
    description: { en: "How we craft mosaics — eight meticulous stages from quarry stone sourcing to hand-cutting, assembly, finishing and presentation.", tr: "Mozaiği nasıl yapıyoruz — ocaktan taş temininden el kesimine, montaja, son işleme ve sunuma kadar sekiz titiz aşama." },
  });
  return (
    <div className="bg-[#f7f3ee]">
      <PageHead title={ui.howWeDo} subtitle={ui.processIntro} image="/mosaic/2025/08/how-we-do1.jpeg" />
      <section className="py-16 md:py-24">
        <div className="max-w-[1160px] mx-auto px-5 md:px-8">
          {processSteps.map((s, idx) => (
            <div key={idx} className={`grid md:grid-cols-2 gap-8 md:gap-14 items-center mb-16 md:mb-24 ${idx % 2 === 1 ? "md:[direction:rtl]" : ""}`}>
              <div className="card-img-zoom overflow-hidden h-[340px] md:h-[420px] [direction:ltr]">
                <img src={s.image} alt={tr(s.title)} className="w-full h-full object-cover" />
              </div>
              <div className="[direction:ltr]">
                <span className="font-serif text-6xl text-[#e0d3bf]">0{idx + 1}</span>
                <p className="text-[#a67c52] text-[12px] uppercase tracking-luxe mt-2 mb-3">{tr(s.subtitle)}</p>
                <h2 className="font-serif text-3xl md:text-4xl text-[#211d18] mb-5">{tr(s.title)}</h2>
                <p className="text-[#5a5348] text-[16px] leading-relaxed">{tr(s.text)}</p>
              </div>
            </div>
          ))}
          <div className="text-center">
            <Link to="/contact" className="inline-flex items-center gap-3 bg-[#a67c52] hover:bg-[#8f6844] text-white text-[13px] uppercase tracking-[0.16em] px-9 py-4 transition-colors">
              {ui.getInTouch} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Process;
